import React from 'react';
import { Mail, Heart } from 'lucide-react';
import touchpadImage from './assets/ic_notification_pointer.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 to-indigo-800 rounded-xl flex items-center justify-center shadow-lg">
                {/* <span className="text-white font-bold text-xl">T</span> */}
                <img
                  src={touchpadImage}
                  alt="Touchpad"
                  className="p-2 hover:scale-110 transition-transform"
                />
              </div>
              <span className="text-2xl font-bold text-white">Touchpad for big phone</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              The ultimate Android touchpad app for one-handed control and accessibility. Navigate your entire screen with ease.
            </p>
          </div>

          {/* Quick Links */}
          {/* <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.location.href = '/#features';
                    }
                  }}
                  className="text-gray-400 hover:text-indigo-400 transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.location.href = '/#how-it-works';
                    }
                  }}
                  className="text-gray-400 hover:text-indigo-400 transition-colors"
                >
                  How It Works
                </button>
              </li> */}
              {/* <li>
                <button
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.location.href = '/#download';
                    }
                  }}
                  className="text-gray-400 hover:text-indigo-400 transition-colors"
                >
                  Download
                </button>
              </li> */}
              {/* <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.mpointer.touchpad.bigphones"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-indigo-400 transition-colors"
                >
                  Google Play Store
                </a>
              </li> */}
              {/* <li>
                <a
                  href="/privacy-policy"
                  className="text-gray-400 hover:text-indigo-400 transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div> */}

          {/* Contact */}
          {/* <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Get In Touch</h3>
            <p className="text-gray-400">
              Have questions or feedback? We'd love to hear from you!
            </p>
            <div className="flex space-x-4">
              <a
                href="mailto:mpointerquery@gmail.com"
                className="w-10 h-10 bg-gray-800 hover:bg-indigo-600 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {/* © {currentYear} Touchpad App. All rights reserved. */}
            </p>
            <div className="flex items-center space-x-1 text-gray-400 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-red-500 mx-1" />
              <span>for Android users</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
